<template>
  <div>
    <Header :getList="getList"></Header>
    <!-- 高亮方法地址 -->
    <!-- https://blog.csdn.net/qq_25403957/article/details/81111437?ops_request_misc=%257B%2522request%255Fid%2522%253A%2522161847090916780269880980%2522%252C%2522scm%2522%253A%252220140713.130102334.pc%255Fall.%2522%257D&request_id=161847090916780269880980&biz_id=0&utm_medium=distribute.pc_search_result.none-task-blog-2~all~first_rank_v2~rank_v29-17-81111437.first_rank_v2_pc_rank_v29&utm_term=%E6%90%9C%E7%B4%A2%E9%AB%98%E4%BA%AE&spm=1018.2226.3001.4187 -->
    <div style="margin:20px 0; ">
      <div class="content">
        <div class="lable">
          <div
            v-for="(item,index) in labledata"
            :key="index"
            :class="{heightlight : lableindex==index}"
            @click="lableArea(index,item)"
          >
            {{item}}
            <div v-if="lableindex==index" class="xian"></div>
          </div>
        </div>

        <div class="screen">
          <div class="cate_police">
            <div class="cate-all">排序：</div>
            <div class="subject">
              <span
                v-for="(item, index) in sortdata"
                :key="index"
                :class="{active : sortindex==index}"
                @click="sortArea(index,item)"
              >{{ item }}</span>
            </div>
          </div>

          <div class="cate_police">
            <div class="cate-all">时间排序:</div>
            <div class="subject">
              <span
                v-for="(item, index) in timedata"
                :key="index"
                :class="{active : timeindex==index}"
                @click="timeArea(index,item)"
              >{{ item }}</span>
            </div>
          </div>

          <!-- <div class="sort">
                        <span style="font-weight:700;font-size:16px">排序：</span>
                        <div v-for="(item,index) in sortdata" :key="index" :class="{active : sortindex==index}" @click="sortArea(index,item)" style="color:#fff">{{item}}</div>
          </div>-->
          <!-- <div class="time">
                        <span style="font-weight:700;font-size:16px">时间排序:</span>
                        <div v-for="(item,index) in timedata" :key="index" :class="{active : timeindex==index}" @click="timeArea(index,item)">{{item}}</div>
          </div>-->
          <hr style="margin-top:20px" />
        </div>

        <div class="metter">
          <div v-if="count==0" style="font-size:20px;font-weight:700">
            <nodata />
          </div>
          <div
            class="metterdata"
            v-for="(item,index) in searchList"
            :key="index"
            @click="skipToSecond(item)"
            v-else
          >
            <div class="metterdatatop">
              <div>{{item.yw_name}}</div>
              <div v-html="item.title" style="font-size:16px"></div>
            </div>
            <div class="metterdatafoot">
              <div>来源：{{item.deptname}}</div>
              <div>{{item.createtime}}</div>
            </div>
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.page"
            layout="total, prev, pager, next"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../header_copy/index';
import { SearchAllHome } from '@/api/public.js';
export default {
  components: {
    Header,
  },
  data() {
    return {
      count: 0,
      labledata: [
        '全部',
        '信息',
        '资源',
        '考试',
        '调训',
        '教官',
        '证书',
        '问卷',
      ],
      lableindex: 0,
      sortdata: ['智能排序', '时间排序'],
      sortindex: 0,
      timedata: ['全部', '一天以内', '一周以内', '一月之内', '一年之内'],
      timeindex: 0,
      currentPage2: 1,
      searchList: [],
      listQuery: {
        page: 1,
        limit: 10,
        key: '',
        orderType: 0,
        dateType: 0,
        ywType: 0,
      },
      krouter: localStorage.getItem('Kroute'),
    };
  },
  created() {
    if (this.krouter == '/home') {
      this.listQuery.ywType = 0;
      this.lableindex = 0;
    } else if (this.krouter == '/mooc') {
      this.listQuery.ywType = 2;
      this.lableindex = 2;
    } else if (this.krouter == '/sourceslist') {
      this.listQuery.ywType = 3;
      this.lableindex = 3;
    } else if (this.krouter == '/exam') {
      this.listQuery.ywType = 4;
      this.lableindex = 4;
    } else if (this.krouter == '/train') {
      this.listQuery.ywType = 5;
      this.lableindex = 5;
    } else if (this.krouter == '/diaoa') {
      this.listQuery.ywType = 6;
      this.lableindex = 6;
    } else if (this.krouter == '/certificate') {
      this.listQuery.ywType = 7;
      this.lableindex = 7;
    } else if (this.krouter == '/diaoy') {
      this.listQuery.ywType = 8;
      this.lableindex = 8;
    }
    this.getList();
  },
  destroyed() {
    localStorage.removeItem('Kroute');
    localStorage.removeItem('keyworks');
  },
  updated() {
    // this.getList()
  },
  methods: {
    lableArea(index, item) {
      this.lableindex = index;
      if (index > 1) {
        this.listQuery.ywType = index + 1;
      } else {
        this.listQuery.ywType = index;
      }

      this.getList();
    },
    sortArea(index, item) {
      this.sortindex = index;
      this.listQuery.orderType = index;
      this.getList();
    },
    timeArea(index, item) {
      this.timeindex = index;
      this.listQuery.dateType = index;

      this.getList();
    },
    getList() {
      this.listQuery.key = localStorage.getItem('keyworks');
      SearchAllHome(this.listQuery).then((res) => {
        // console.log(res)
        // this.searchList=res.data
        this.count = res.count;
        this.changeColor(res.data);
      });
    },
    changeColor(resultsList) {
      // resultsList全部数据，改变title里的高亮颜色，用正则先去匹配全局匹配到，然后用字符串的替换将原来的title替换需要高亮的部分
      resultsList.map((item, index) => {
        // console.log('item', item)
        if (this.listQuery.key && this.listQuery.key.length > 0) {
          // 匹配关键字正则
          let replaceReg = new RegExp(this.listQuery.key, 'g');
          // 高亮替换v-html值
          let replaceString =
            '<span class="search-text" style="color:red;font-weight: 700;">' +
            this.listQuery.key +
            '</span>';
          resultsList[index].title = item.title.replace(
            replaceReg,
            replaceString
          );
        }
      });
      // this.results = []
      // this.results = resultsList
      this.searchList = [];
      this.searchList = resultsList;
    },
    skipToSecond(item) {
      if (item.yw_type == 1) {
        //信息
        // this.$router.push({
        //     path: '/search',
        //     query: {},
        // });
      } else if (item.yw_type == 2) {
        //微课
        this.$router.push({
          path: '/studyclassDetail',
          query: {
            id: item.id,
          },
        });
      } else if (item.yw_type == 3) {
        //资源
        this.$router.push({
          path: '/sourceslist/videoLearn',
          query: {
            id: item.id,
          },
        });
      } else if (item.yw_type == 4) {
        //考试
        // this.$router.push({
        //     path: '/studyclassDetail',
        //     query: {
        //         id:item.id
        //     },
        // });
      } else if (item.yw_type == 5) {
        // 调训
        this.$router.push({
          path: '/train/trainBase',
          query: {
            id: item.id,
          },
        });
      } else if (item.yw_type == 6) {
        // 教官
        this.$router.push({
          path: '/diaoa/personData',
          query: {
            id: item.id,
          },
        });
      } else if (item.yw_type == 7) {
        // 电子证书
        // this.$router.push({
        //     path: '/studyclassDetail',
        //     query: {
        //         id:item.id
        //     },
        // });
      } else if (item.yw_type == 8) {
        // 问卷
        this.$router.push({
          path: '/diaoy/questionget',
          query: {
            id: item.id,
          },
        });
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.listQuery.page = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.content {
  width: 1200px;
  min-height: 600px;
  background-color: #fff;
  margin: 0 auto;
  /* box-shadow: 3px 3px 10px rgba(215, 215, 215, 0.988235294117647); */
  border: solid 1px #f2f2f2;
  padding-bottom: 20px;
}
.heightlight {
  color: #409eff !important;
}
.active {
  background-color: #409eff !important;
  /* border: 1px solid #4876C4; */
  color: #f8fafc !important;
}
.lable {
  width: 1000px;
  height: 40px;
  border-bottom: solid 1px #ccc;
  margin: 0 auto;
  padding-top: 20px;
  display: flex;
}
.lable > div {
  flex: 1;
  text-align: center;
  line-height: 40px;
  font-size: 20px;
  cursor: pointer;
}
.lable > div:hover {
  color: rgb(57, 199, 247);
}
.xian {
  width: 50px;
  border: solid 1px rgb(57, 199, 247);
  margin-left: 30px;
}
.screen {
  width: 1000px;
  height: 140px;
  /* border:solid 1px #ccc; */
  margin: 0 auto;
  margin-top: 20px;
}
.sort {
  margin-top: 10px;
  padding-left: 50px;
  display: flex;
}
.sort > div,
.time > div {
  margin-left: 14px;
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: rgb(194, 194, 194);
  border-radius: 10px;
  cursor: pointer;
}
.time {
  margin-top: 10px;
  padding-left: 50px;
  display: flex;
}
.metter {
  width: 1000px;
  min-height: 400px;
  margin: 0 auto;
  /* border:solid 1px #ccc; */
}
.metterdata {
  width: 1000px;
  height: 100px;
  cursor: pointer;
  /* border:solid 1px #ccc; */
  margin-top: 5px;
  /* box-shadow: 3px 3px 10px rgba(236, 236, 236, 0.988); */
  border: solid 1px #f2f2f2;
}
.metterdata:hover {
  width: 1000px;
  height: 99px;
  border: solid 1px rgb(35, 185, 245);
}
.metterdatatop {
  padding-top: 3px;
  display: flex;
}
.metterdatatop > div:nth-child(1) {
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  border-radius: 5px;
  margin-top: 5px;
  margin-left: 10px;
  background-color: rgb(35, 185, 245);
}
.metterdatatop > div:nth-child(2) {
  height: 30px;
  line-height: 30px;
  margin-top: 5px;
  margin-left: 10px;
}
.metterdatafoot {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  color: #7f7f7f;
}
.metterdatafoot > div:nth-child(1) {
  margin-left: 12px;
}
.metterdatafoot > div:nth-child(2) {
  margin-right: 12px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.search-text {
  color: red;
}
.cate {
  width: 1180px;
  background: #ffffff;
  margin: 0 auto;
  margin-top: 20px;
  padding: 10px;
  box-shadow: 2px 2px 5px rgb(215 215 215 / 35%);
  border-radius: 10px;
}
.cate_police {
  display: flex;
  font-size: 16px;
  margin-left: 32px;
  padding: 5px 0;
  /* height: 100px; */
}
.cate-all {
  width: 110px;
}
.subject {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.subject > span {
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  margin-right: 10px;
  /* background: #ECECEC; */
  opacity: 1;
  border-radius: 6px;
  margin-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid white;
  border-radius: 5px;
}
.subject > span:hover {
  border: 1px solid #3c95d6;
  color: #3c95d6;
  border-radius: 5px;
}
</style>